import validate from "/service/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirects_45global from "/service/src/middleware/01.redirects.global.js";
import _02_45load_45global from "/service/src/middleware/02.load.global.js";
import manifest_45route_45rule from "/service/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirects_45global,
  _02_45load_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}